import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./pressure.css";

import { Link } from "react-router-dom";
export default function ControlesNonDestructifsView() {
  const sliderSettings = {
    dots: true,
    arrows: false,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 3000,
    slidesToShow: 1,
    slidesToScroll: 1,
    speed: 700,
    pauseOnHover: false,
  };

  return (
    <>
      <Header />

      <main className="prs">
        {/* ===== HERO SECTION ===== */}
        <section className="prs-hero">
          <div className="prs-hero__text">
            <h1>Contrôles Non Destructifs (CND)</h1>
            <p>
              VERATRAC SAFETY réalise des contrôles non destructifs pour évaluer
              l’intégrité des matériaux, des structures et des assemblages sans
              les détériorer. Ces inspections garantissent la sécurité, la
              fiabilité et la conformité des installations industrielles et
              mécaniques.
            </p>

            <div className="prs-hero__bullets">
              <span>🔬 Contrôle par ressuage & magnétoscopie</span>
              <span>📡 Ultrasons & radiographie industrielle</span>
              <span>⚙️ Suivi de corrosion & épaisseurs</span>
            </div>

            <a href="#contact" className="btn-primary">
              Demander une intervention
            </a>
          </div>

          <div className="prs-hero__slider">
            <Slider {...sliderSettings}>
              <div><img src="/images/cnd/1.jpg" alt="Inspection par ressuage" /></div>
              <div><img src="/images/cnd/3.jpg" alt="Contrôle ultrason" /></div>
              <div><img src="/images/cnd/1.jpg" alt="Analyse radiographique" /></div>
              <div><img src="/images/cnd/3.jpg" alt="Mesure d’épaisseur" /></div>
              <div><img src="/images/cnd/1.jpg" alt="Contrôle magnétoscopique" /></div>
            </Slider>
          </div>
        </section>

        {/* ===== SECTION TECHNIQUE ===== */}
        <section className="prs-reglement prs-simple">
          <h2>Notre expertise en CND</h2>
          <p>
            Les <strong>contrôles non destructifs (CND)</strong> permettent de
            détecter les défauts internes ou de surface d’un matériau sans
            altérer sa structure.  
            Ils constituent un élément essentiel du contrôle qualité, de la
            maintenance prédictive et de la prévention des risques industriels.
          </p>

          <h3>Méthodes utilisées</h3>
          <ul>
            <li><strong>Ressuage (PT)</strong> : détection de fissures et porosités sur pièces non ferromagnétiques.</li>
            <li><strong>Magnétoscopie (MT)</strong> : inspection de surface des aciers et pièces ferromagnétiques.</li>
            <li><strong>Ultrasons (UT)</strong> : mesure d’épaisseur, recherche de discontinuités internes.</li>
            <li><strong>Radiographie (RT)</strong> : détection de défauts internes par rayons X ou gamma.</li>
            <li><strong>Courants de Foucault (ET)</strong> : contrôle de surface pour métaux conducteurs.</li>
          </ul>

          <h3>Domaines d’application</h3>
          <ul>
            <li>Construction métallique et soudure industrielle.</li>
            <li>Équipements sous pression et réservoirs.</li>
            <li>Structures de levage, grues et ponts roulants.</li>
            <li>Composants aéronautiques et ferroviaires.</li>
            <li>Inspection d’ouvrages de génie civil.</li>
          </ul>

          <h3>Avantages du contrôle non destructif</h3>
          <ul>
            <li>Préservation totale de la pièce inspectée.</li>
            <li>Détection précoce des défauts avant rupture ou fuite.</li>
            <li>Évaluation rapide de l’état d’usure ou de corrosion.</li>
            <li>Fiabilité accrue du suivi maintenance et sécurité.</li>
          </ul>

          <h3>Référentiels & normes</h3>
          <p>
            Nos interventions respectent les exigences des normes
            <strong> ISO 9712, EN 17635, ASTM, ASME Section V </strong> et des
            règlements marocains en vigueur.  
            Les opérateurs VERATRAC SAFETY sont qualifiés selon les niveaux
            <strong> I, II et III</strong> par des organismes agréés.
          </p>

          <h3>Rapports et livrables</h3>
          <ul>
            <li>Fiches de mesure détaillées et résultats d’analyse.</li>
            <li>Photos et cartographie des zones contrôlées.</li>
            <li>Rapport d’inspection avec interprétation des défauts.</li>
            <li>Recommandations techniques et plan de suivi.</li>
          </ul>

          <div className="prs-btns">
            <Link to="/#contact" className="btn-primary">faire une consultation</Link>
          </div>
        </section>
      </main>

      <Footer />
    </>
  );
}
